import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {RepairDto} from "../../../../auto-generated-server-dtos/claim/repairs/repair-dto";

@Injectable({
  providedIn: 'root'
})
export class SaveRepairService {

  constructor(private httpClient: HttpClient) {}

  saveRepair(repair: RepairDto) {
    return this.httpClient.put(`${environment.apiServer}/SaveRepair`, repair);
  }
}
